//Author June Leow
//Date June 10th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, confirmation, formatDateTime} from '../../util/util';
import {Button,Input,Modal, ModalHeader, ModalBody, Row, Col, Table} from 'reactstrap';
import './comment.css';
import {NavLink} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  comments: [],
  newComment:'',
  modal: false,
  commentTemplates:[],

  waitingOnContactMessage:'',
  waitingOnContactComment:'',
  hadPurchaseContract:false,
  submitDisabled:false
};

//reducer function that perform state update
const reducer = getReducer();


const Comment  = (props)=>{
  const controller = new AbortController();

  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraisalComments();
    getCommentTemplates();
    getAppraisalFiles();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const buttonHandler=()=>{
    if(state.submitDisabled)
      return;
    if(state.newComment==='')
      return;

    setState({submitDisabled:true},postComment());
  }

  const waitingOnContactToggle=()=>{
    setState({
      waitingOnContactDropdownOpen: !state.waitingOnContactDropdownOpen
    });
  }

  const toggle=()=>{
    setState({
      modal: !state.modal
    });
  }

  const onChange=(e)=>{
    setState({newComment:e.target.value});
  }

  //on change function listen for change on the select drop down of comment templates
  //populate the textarea onchange
  const commentTemplatesOnChange=(e)=>{
    let id = e.target.value;

    let template;

    for(let i=0;i<state.commentTemplates.length;i++){
      if(state.commentTemplates[i].ID===id){
        template = state.commentTemplates[i];
        break;
      }
    }

    if(template){
      setState({newComment:template.template});
    }
  }


  //API call
  //get all the comments
  const getAppraisalComments=()=>{
    let callBack = (response)=>{
      let code = response.data?response.data.code:undefined;
      if(code==='00'){
        response.data.data.reverse();
        setState({
          comments:response.data.data,
        });
      }
    };
    httpGet('comment/get/'+props.appraisalFk, '', 'Oops, something went wrong and could not load comments for this appraisal. Please try again later.', callBack);
  }

  //get all the comment templates
  const getCommentTemplates=()=>{
    const callBack = apiCallBack([{state:'commentTemplates', key:'data'}]);
    httpGet('template/get/'+props.appraisalFk, '', 'Oops, something went wrong and could not load your comment template.', callBack);
  }

  const waitingOnContact=(reason)=>{
    let error = true;
    switch(reason){
      case 1:
      case 2:
      case 3:
        error = false;
        break;
      case 4:
        if(state.waitingOnContactComment===''){
          error = true;
          setState({waitingOnContactMessage:'Please provide comment to the AMC in the text box below.'});
        }
        else
          error = false;
        break;
      default:
        error  = true;
        setState({waitingOnContactMessage:'Invalid selection.'});
        break;
    }

    if(error!==true){
      let parameters = [
        {
          field:'ID',
          value:props.appraisalFk
        },
        {
          field:'reason',
          value:reason
        }
      ];

      if(reason===4){
        let tmp = {
          field:'comment',
          value:state.waitingOnContactComment
        };

        parameters.push(tmp);
      }

      let callBack = (response)=>{
        let code = response.data.code;
        waitingOnContactToggle();
      };
      httpPost('appraisal/waitingOnContact', parameters, 'Order set to waiting on contact.','Oops, something went wrong and could not set the order to waiting on contact. Please try again later.', callBack);
    }
  }

  const sendPurchaseContractReminder=()=>{
    let parameters = [
      {
        field:'ID',
        value:props.appraisalFk
      }
    ];
    httpPost('file/purchaseContract/reminder', parameters, 'Purchase contract reminder sent.', 'Oops, something went wrong and could not send the reminder. Please try again later.', ()=>{});
  }
  
  const postComment=()=>{
    let parameters = [
      {
        field:'comment',
        value:state.newComment
      },
      {
        field:'appraisal_fk',
        value:props.appraisalFk
      },
      {
        field:'to_send_entities',
        value:state.targetRecipients
      }
    ];

    let callBack = (response)=>{
      setState({submitDisabled:false});
      let code = response.data.code;
      if(code==='00'){
        console.log(response.data.data)
        //insert new comment into state
        let commentCreated = response.data.data;
        let existingComments = state.comments.slice();
        existingComments.unshift(commentCreated);
        setState({comments:existingComments, newComment:''});
      }
    };
    httpPost('comment/create', parameters, 'Comment posted successfully.', 'Oops, something went wrong and could not post this comment. Please try again later.', callBack);
    toggle();
  }

  const getAppraisalFiles=()=>{
    //Call Back
    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        for(let i=0;i<response.data.data.length;i++){
          console.log(response.data.data[i].file_type);
          if(response.data.data[i].file_type==='Purchase Contract'||response.data.data[i].file_type==='Contract Addendum'||(response.data.data[i].name.indexOf('contract')!==false&&response.data.data[i].name.indexOf('contract')!==-1)){
            setState({hadPurchaseContract:true});
            console.log('had contract');
          }
        }
      }
    };

    httpGet('file/get/'+props.appraisalFk, '', 'Oops, something went wrong and could not load appraisal files for this appraisal. Please try again later.', callBack);
  }

  //render
  let templates;

  if(state.commentTemplates){
    templates = state.commentTemplates.map(
      (template)=>{
        return(
          <option key={template.ID} value={template.ID}>{template.name}</option>
        );
      }
    );
  }

  let purchaseContractReminder;

  if(props.loan_purpose==='Purchase'){
    let confirmationStr = 'Do you want to send a purchase contract missing reminder to the client?';

    if(state.hadPurchaseContract)
      confirmationStr = 'It seems like the purchase contract is already in the document storage, do you still want to send the reminder?';

    purchaseContractReminder =
    <Button color="warning" className="cursor-pointer" onClick={
      ()=>{
        confirmation(
          ()=>{sendPurchaseContractReminder()},
          ()=>{},
          'Purchase contract reminder',
          confirmationStr);
      }
    }><i className="fa fa-plus"></i> Purchase Contract Reminder</Button>
  }

  let waitingOnContactWidget;

  if(props.status==='Pending Inspection'){
    waitingOnContactWidget =
    <Button color="warning" className="cursor-pointer" onClick={waitingOnContactToggle}><i className="fa fa-plus"></i> Waiting On Contact</Button>
  }

  let comments = state.comments.map(
    (comment,outterIndex)=>{
      let outterContainerClass = 'align-right';
      let commentContainerClass = 'nonadmin-comment-container';
      let nameClass = 'nonadmin-name';
      let alignClass = 'align-left';
      let alignClass2 = 'align-right';
      let dateClass = 'margin-top comment-date display-inline';
      let nameAddon = '';

      if(comment.internal==='yes'){
        outterContainerClass = '';
        commentContainerClass = 'admin-comment-container';
        nameClass = 'admin-name';
      }

      let namePortion = <div className={(commentContainerClass==='admin-comment-container'?alignClass:alignClass2)+" display-inline"}>
        <div className="display-inline">
        
        </div>
        &nbsp;
        <div className="display-inline"><b>{nameAddon+comment.author}</b></div>
      </div>;



      let datePortion = <Row>
        <Col sm="5" className="align-left">
        </Col>
        <Col sm="7">
          <div className={dateClass}><i className="fa fa-reply cursor-pointer"/> {formatDateTime(comment.datetime_created)}</div>
        </Col>
      </Row>;

      
      let avatar = <div className="align-right display-inline">
        <i className="fa fa-circle-user" style={{fontSize:'30px'}}/>
      </div>;

      if(comment.author_profile_photo && comment.author_profile_photo!==''){
        avatar = <div className="align-right display-inline">
        <img src={comment.author_profile_photo} width="30px"/>
      </div>;
      }

      let header = <div>
        {namePortion} {avatar} 
      </div>

      if(commentContainerClass==='admin-comment-container'){
        namePortion = <div className="display-inline">
        <div className="display-inline">{nameAddon+comment.author}</div>
      </div>;

        datePortion = <Row>
          <Col sm="7">
            <div className={dateClass+" "+(commentContainerClass==='admin-comment-container'?alignClass:alignClass2)}><i className="fa fa-reply cursor-pointer"/> {formatDateTime(comment.datetime_created)}</div>
          </Col>
          <Col sm="5" className="align-right">
          </Col>
        </Row>;

        header = <div>
          {avatar} {namePortion} 
          </div>
      }

      return(
        <div key={comment.ID}>
          <div className={(commentContainerClass==='admin-comment-container'?alignClass:alignClass2)} style={{marginBottom:'-5px'}}>
            {header}
          </div>
          <Row className={outterContainerClass+" "+(commentContainerClass==='admin-comment-container'?alignClass:alignClass2)}>
            <Col sm="12">
              <div className={commentContainerClass+(comment.ID===state.commentID?" highlightit":"")}>
                <div className="display-inline" dangerouslySetInnerHTML={{ __html: comment.comment }} />
                {datePortion}
              </div>
            </Col>
          </Row>
          <br/>
        </div>
        
      );
    }
  );

  return(
    <div>
      <div className="comments-panel">
        {comments}
      </div>
      <div className="my-diviver"></div>
      <div className="align-right">
        <br/>

        {waitingOnContactWidget}&nbsp;
        {purchaseContractReminder}&nbsp;
        <Button color="warning" className="cursor-pointer" onClick={toggle}><i className="fa fa-plus"></i> Post a message to @Home</Button>
        <Modal className="my-modal" isOpen={state.modal} toggle={toggle} >
          <ModalHeader hidden={true} toggle={toggle}></ModalHeader>
          <ModalBody>
            <center>
              <h5><i className="fa fa-comments"></i> New Comment</h5>
            </center>
            <br/>
            <div className="form-group">
              <span><label>Comment:</label></span>
              <Input type="textarea" className="form-control comment-textarea" value={state.newComment} id="comment" placeholder="Say something..." style={{resize:'none'}} rows="8" onChange={onChange}></Input>
            </div>

            <Row>
              <Col sm="6">
                <label>Template:</label>
              </Col>
              <Col sm="6" className="align-right">
                <NavLink to="/setting">Manage my template</NavLink>
              </Col>
            </Row>
            <br/>

            <select className="form-control" onChange={commentTemplatesOnChange}>
              <option value=""></option>
              {templates}
            </select>

            <br/>
            <center>
              <Button color="warning" disabled={state.submitDisabled!==false} onClick={buttonHandler} ><i className="fa fa-check"></i>&nbsp;Post</Button>{' '}
              <Button color="info" onClick={toggle}>Close</Button>
            </center>
          </ModalBody>
        </Modal>
        <Modal className="my-modal" isOpen={state.waitingOnContactDropdownOpen} toggle={waitingOnContactToggle} >
          <ModalHeader hidden={true} toggle={waitingOnContactToggle}></ModalHeader>
          <ModalBody>
            <label>Select option below to move order to "Waiting On Contact"</label>

            <div className="small-scroll-container"><font color="red">{state.waitingOnContactMessage}</font></div>
            <Table className="table" hover>
              <tbody>
                <tr className="cursor-pointer" onClick={()=>waitingOnContact(1)}>
                  <td>
                    <label>Waiting To Hear Back</label><br/>
                    Hello, we have reached out to the property contact and are waiting to hear back.<br/>
                  </td>
                </tr>
                <tr className="cursor-pointer" onClick={()=>waitingOnContact(2)}>
                  <td>
                    <label>Left Second Message</label><br/>
                    Hello, we have left a second message to the property contact and are still waiting to hear back. Please advise.<br/>
                  </td>
                </tr>
                <tr className="cursor-pointer" onClick={()=>waitingOnContact(3)}>
                  <td>
                    <label>Waiting To Hear Back</label><br/>
                    Hello, it appears the contact info is incorrect. Can you please provide additional phone number(s) or contact for property access?<br/>
                  </td>
                </tr>
                <tr className="cursor-pointer" onClick={()=>waitingOnContact(4)}>
                  <td>
                    <label>Contact AMC</label><br/>
                    If none of these above apply and you wish to contact the AMC directly and move the order to "Waiting On Contact" please type your comment then select this option.<br/>
                  </td>
                </tr>
              </tbody>
            </Table>
            <Input type="textarea" style={{rows:'3'}} value={state.waitingOnContactComment} onChange={(e)=>setState({waitingOnContactComment:e.target.value})}></Input>
            <div className="my-divider">&nbsp;</div>
            <center>
              <Button color="info" onClick={waitingOnContactToggle}>Close</Button>&nbsp;
            </center>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
}


export default Comment;
